<template>
  <el-breadcrumb class="breadcrumb" separator="/">
    <el-breadcrumb-item :to="{ path: '/' }">
      <i class="el-icon-s-home"></i>
    </el-breadcrumb-item>
    <el-breadcrumb-item
      v-for="(item, index) in list"
      v-if="!item.hidden"
      :key="item.name"
    >
      <span
        class="no-redirect"
        v-if="item.redirect === 'noredirect' || index === list.length - 1"
      >
        {{ $l(item.meta.title) }}
      </span>
      <router-link v-else :to="item.redirect || item.path">
        {{ $l(item.meta.title) }}
      </router-link>
    </el-breadcrumb-item>
  </el-breadcrumb>
</template>

<script>
export default {
  name: "breadcrumb",
  data() {
    return {
      list: null,
    };
  },
  created() {
    this.getBreadcrumb();
  },
  watch: {
    $route() {
      this.getBreadcrumb();
    },
  },
  methods: {
    getBreadcrumb() {
      let matched = this.$route.matched.filter((item) => item.name);
      this.list = matched;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.breadcrumb {
  margin-bottom: 20px;
  background: blue;
  .el-breadcrumb__item svg {
    width: 1em;
    height: 1em;
    // text-shadow: 0 2px 2px rgba(0, 0, 0, 0.2);
  }
  .el-breadcrumb__inner.is-link,
  .el-breadcrumb__inner a {
    // color: lighten($--color-calm-sub, 20%);
    // text-shadow: 0 2px 2px rgba($--color-text-primary, 0.3);
    text-shadow: 0 2px 1px rgba(#21214e, 0.3);
    color: #fff;
    // text-shadow: 0 2px 2px rgba($--color-text-primary, 0.5);
    &:hover {
      // color: $--color-primary;
      color: darken($--color-primary, 10%);
    }
  }
  .el-breadcrumb__item:last-child .el-breadcrumb__inner,
  .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover,
  .el-breadcrumb__item:last-child .el-breadcrumb__inner a,
  .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover {
    color: lighten($--color-text-placeholder, 20%);
    text-shadow: 0 2px 1px rgba(#21214e, 0.3);
  }
  .el-breadcrumb__separator {
    color: rgba(#fff, 0.3);
  }
}
</style>
